import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "overrides", "className", "isRequired", "hint", "isDisabled"];
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Popover from '../../utils/Popover';
import Icon from '../../general/Icon';
import Text from '../../typography/Text';
import { createUseStyles } from '../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'Label');
function Label(_ref) {
  var children = _ref.children,
    classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    isRequired = _ref.isRequired,
    hint = _ref.hint,
    isDisabled = _ref.isDisabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  // Overrides
  var override = getOverrides(overridesProp, Text.overrides);

  // Classes
  var rootClassName = classnames(classes.root, classNameProp);
  var rootProps = {
    className: rootClassName
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, rootProps, override.root), /*#__PURE__*/React.createElement(Text, _extends({
    type: isDisabled ? 'light' : 'body',
    className: classes.Text
  }, override.Text), children, isRequired && '*'), hint && /*#__PURE__*/React.createElement(Popover, _extends({
    className: classes.Popover,
    placement: "top",
    trigger: ['hover'],
    content: hint
  }, override.Popover), /*#__PURE__*/React.createElement("span", {
    className: classes.info
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon,
    name: "info"
  }))));
}
Label.overrides = ['root', 'Popover', 'Text'];
Label.defaultProps = {
  overrides: {}
};
process.env.NODE_ENV !== "production" ? Label.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  isRequired: PropTypes.bool,
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
} : void 0;
export default /*#__PURE__*/React.memo(Label);